import { render, staticRenderFns } from "./FiatSection.vue?vue&type=template&id=3ccc2ada"
import script from "./FiatSection.vue?vue&type=script&lang=js"
export * from "./FiatSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports